import { useEffect, useState } from "react";
import "../Common/css/styles.css";
import "../Common/css/user.css";
import { createAdmin, deleteAdmin, getAdminDetails, resetAdminPassword, resetInsPassword, updateAdmin } from "src/Services/user_api";
import { Button, Checkbox, Dialog, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Menu, MenuItem, Radio, RadioGroup, Select, TextField } from "@mui/material";
import { Close, MoreVert } from "@mui/icons-material";
import { PlusOutlined } from "@ant-design/icons";
import TableToolbar from "src/Components/TableToolbar";
import CustomAlert from "src/Components/Alerts";
import Spinner from "src/Components/Spinner";
import Dialogbox from "src/Components/Dialogbox";
import { id, is } from "date-fns/locale";
import { deleteInstructor, getAllInstructors } from "src/Services/instructor_api";
import { createInstructor, updateInstructor } from "src/Services/admin_api";

const ITEMS_PER_PAGE = 5;

export default function InstructorMaintenance() {
  const token = sessionStorage.getItem("token") || "";
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertDescription, setAlertDescription] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error" | "warning">("success");
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [instructors, setInstructors] = useState<any[]>([]);
  const [instructorSubjects, setInstructorSubjects] = useState<any[]>([]);
  const [filteredInstructors, setFilteredInstructors] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedInstructor, setSelectedInstructor] = useState<any>();
  const [openModal, setOpenModal] = useState(false);
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [emergencyContactNumber, setEmergencyContactNumber] = useState("");
  const [nic, setNic] = useState("");
  const [gender, setGender] = useState("");
  const [instructorType, setAdminType] = useState(1);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);

  const subjectCombinations = [
    { programme: "Fast track A/L", stream: "Arts Stream", subject: "Econ" },
    { programme: "Fast track A/L", stream: "Arts Stream", subject: "Media" },
    { programme: "Fast track A/L", stream: "Arts Stream", subject: "ICT" },
    { programme: "Fast track A/L", stream: "Arts Stream", subject: "Sinhala" },
    { programme: "Fast track A/L", stream: "Arts Stream", subject: "Political Science" },
    { programme: "Fast track A/L", stream: "Commerce Stream", subject: "Business Studies" },
    { programme: "Fast track A/L", stream: "Commerce Stream", subject: "Accounts" },
    { programme: "Fast track A/L", stream: "Commerce Stream", subject: "Econ" },
    { programme: "Fast track A/L", stream: "Commerce Stream", subject: "ICT" },
    { programme: "Fast track A/L", stream: "Technology Stream", subject: "Engineering Technology" },
    { programme: "Fast track A/L", stream: "Technology Stream", subject: "Science For Technology" },
    { programme: "Fast track A/L", stream: "Technology Stream", subject: "ICT" },
    { programme: "Fast track A/L", stream: "General English in A/L", subject: null },
    { programme: "Diploma", stream: "Diploma in Marketing", subject: null },
    { programme: "Diploma", stream: "Diploma in HRM", subject: null },
    { programme: "Diploma", stream: "Diploma in English", subject: null },
    { programme: "Diploma", stream: "Diploma in ICT", subject: null },
    { programme: "Certificate course", stream: "Certificate course in Marketing", subject: null },
    { programme: "Certificate course", stream: "Certificate course in HRM", subject: null },
    { programme: "Certificate course", stream: "Certificate course in English", subject: null },
    { programme: "Certificate course", stream: "Certificate course in ICT", subject: null },
  ];

  const handleSubjectToggle = (combo: any) => {
    const exists = instructorSubjects.find(
      (s) =>
        s.programme === combo.programme &&
        s.stream === combo.stream &&
        s.subject === combo.subject
    );

    if (exists) {
      // remove if already selected
      setInstructorSubjects((prev) =>
        prev.filter(
          (s) =>
            !(
              s.programme === combo.programme &&
              s.stream === combo.stream &&
              s.subject === combo.subject
            )
        )
      );
    } else {
      // add new selection
      setInstructorSubjects((prev) => [...prev, combo]);
    }
  };


  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, instructor: any) => {
    setAnchorEl(event.currentTarget);
    //console.log(`Selected instructor: ${instructor.id}`);

    setSelectedInstructor(instructor);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const showAlert = (description: string, type: "success" | "error" | "warning") => {
    setAlertDescription(description);
    setAlertType(type);
    setAlertOpen(true);
  };

  const handleView = () => {
    if (!selectedInstructor) return;
    setViewDialogOpen(true);
  };

  const handleEdit = () => {
    if (!selectedInstructor) return;
    setName(selectedInstructor.name);
    setEmail(selectedInstructor.email);
    setContactNumber(selectedInstructor.contactNumber);
    setEmergencyContactNumber(selectedInstructor.emergencyContactNumber);
    setAddress(selectedInstructor.address);
    setGender(selectedInstructor.gender);
    setInstructorSubjects(selectedInstructor.instructorSubjects || []);
    setIsViewMode(true);
    setOpenModal(true);
  };

  const handleDelete = async (id: any) => {
    try {
      await deleteInstructor(token, id);
      showAlert("Instructor deleted successfully", "success");
      handleFetchInstructors();
    } catch (error: any) {
      showAlert(error.response.data.message, "error");
    }
    setIsOpen(false);
  };

  useEffect(() => {
    handleFetchInstructors();
  }, []);

  useEffect(() => {
    handleSearch(searchTerm);
  }, [instructors, searchTerm]);

  const handleFetchInstructors = async () => {
    try {
      const res = await getAllInstructors(token);
      setInstructors(res);
    } catch (error) {
      console.error("Error fetching instructors:", error);
    }
  };

  const handleSearch = (term: string) => {
    const lower = term.toLowerCase();
    const filtered = instructors.filter(
      (instructor) =>
        instructor.name.toLowerCase().includes(lower) ||
        instructor.email.toLowerCase().includes(lower)
    );
    setFilteredInstructors(filtered);
    setCurrentPage(1);
  };

  const paginatedInstructors = filteredInstructors.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const totalPages = Math.ceil(filteredInstructors.length / ITEMS_PER_PAGE);

  const validateForm = () => {
    if (!name || !email || !contactNumber || !password || !address || !emergencyContactNumber || !gender) {
      showAlert("Please fill in all fields", "error");
      return false;
    }
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      showAlert("Please enter a valid email address", "error");
      return false;
    }
    const contactPattern = /^\d{10}$/;
    if (!contactPattern.test(contactNumber)) {
      showAlert("Please enter a valid contact number", "error");
      return false;
    }
    const emergencyContactPattern = /^\d{10}$/;
    if (!emergencyContactPattern.test(emergencyContactNumber)) {
      showAlert("Please enter a valid emergency contact number", "error");
      return false;
    }
    return true;
  }

  const validateUpdateForm = () => {
    if (!name || !contactNumber || !address || !emergencyContactNumber || !gender) {
      showAlert("Please fill in all fields", "error");
      return false;
    }
    const contactPattern = /^\d{9}$/;
    if (!contactPattern.test(contactNumber)) {
      showAlert("Please enter a valid contact number", "error");
      return false;
    }
    const emergencyContactPattern = /^\d{9}$/;
    if (!emergencyContactPattern.test(emergencyContactNumber)) {
      showAlert("Please enter a valid emergency contact number", "error");
      return false;
    }
    return true;
  }

  const handleAddInstructor = async () => {
    setIsLoading(true);
    if (!validateForm()) {
      setIsLoading(false);
      return;
    }
    const newInstructor = {
      name,
      password,
      email,
      address,
      contactNumber,
      emergencyContactNumber,
      dob: new Date().toISOString(),
      gender,
      createdBy: sessionStorage.getItem("username"),
      instructorSubjects
    }
    try {
      await createInstructor(token, newInstructor);
      setTimeout(() => {
        setIsLoading(false);
        handleResetForm();
        handleFetchInstructors();
        setOpenModal(false);
        showAlert("Instructor created successfully", "success");
      }, 3000);
    } catch (error: any) {
      setIsLoading(false);
      showAlert(error.response.data.message, "error");
    }
  };

  const handleUpdateInstructor = async () => {
    setIsLoading(true);
    if (!validateUpdateForm()) {
      setIsLoading(false);
      return;
    }
    const updatedInstructor = {
      id: selectedInstructor.id,
      name,
      email,
      contactNumber,
      emergencyContactNumber,
      dob: new Date().toISOString(),
      address,
      gender,
      instructorSubjects
    };

    try {
      await updateInstructor(token, updatedInstructor);
      setTimeout(() => {
        setIsLoading(false);
        handleResetForm();
        handleFetchInstructors();
        setOpenModal(false);
        showAlert("Admin updated successfully", "success");
      }, 3000);
    } catch (error: any) {
      setIsLoading(false);
      showAlert(error.response.data.message, "error");
    }
  };

  const handleResetPassword = async () => {
    setIsLoading(true);
    try {
      await resetInsPassword(token, selectedInstructor.email, selectedInstructor.email.split("@")[0]);
      setTimeout(() => {
        setIsLoading(false);
        handleResetForm();
        handleFetchInstructors();
        setOpenModal(false);
        showAlert("Password reset successfully. Your new password is: " + selectedInstructor.email.split("@")[0], "success");
      }, 3000);
    } catch (error: any) {
      setIsLoading(false);
      showAlert(error.response.data.message, "error");
    }
  }

  const handleResetForm = () => {
    setName("");
    setPassword("");
    setEmail("");
    setAddress("");
    setContactNumber("");
    setEmergencyContactNumber("");
    setNic("");
    setGender("");
    setAdminType(1);
  }

  return (
    <div className="comman-outer">
      <Dialogbox
        open={isOpen}
        title="Delete Instructor"
        content="Are you sure you want to delete this instructor?"
        agreeButtonText="Delete"
        disagreeButtonText="Cancel"
        onAgree={() => handleDelete(selectedInstructor.id)}
        onDisagree={() => setIsOpen(false)}
        onClose={() => setIsOpen(false)}
      />
      <Dialogbox
        open={isOpen2}
        title="Reset Password"
        content="Are you sure you want to reset the password for this instructor?"
        agreeButtonText="Reset"
        disagreeButtonText="Cancel"
        onAgree={() => handleResetPassword()}
        onDisagree={() => setIsOpen2(false)}
        onClose={() => setIsOpen2(false)}
      />
      <CustomAlert
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        description={alertDescription}
        type={alertType}
        timeout={3000}
      />
      <Spinner isLoading={isLoading} />
      <Dialog
        open={viewDialogOpen}
        onClose={() => setViewDialogOpen(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: { backgroundColor: "#c6c2c2e3", color: "white", paddingBottom: 2, borderRadius: 2, boxShadow: 24, border: "1px solid #ffffffff" },
        }}
      >
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", borderBottom: "1px solid #555", backgroundColor: "#393939", padding: "25px 16px" }}>
          <h3>Instructor Details</h3>

        </div>

        <Grid container spacing={2} style={{ padding: "25px 16px", color: "white", backgroundColor: "#6c6b6bff"  }} className="form-grid">
          <Grid item xs={12} sm={6}>
            <strong>Name:</strong> {selectedInstructor?.name}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Email:</strong> {selectedInstructor?.email}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Contact:</strong> {selectedInstructor?.contactNumber}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Contact 2:</strong> {selectedInstructor?.emergencyContactNumber}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Gender:</strong> {selectedInstructor?.gender}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Address:</strong> {selectedInstructor?.address}
          </Grid>
          {/* 
          {selectedInstructor?.instructorSubjects.map((i:any) => {
            const label = `${i.programme}, ${i.stream}${i.subject ? `, ${i.subject}` : ""}`;
            return (
              <Grid item xs={12} sm={6} key={label}>
                <strong>Subject:</strong> {label}
              </Grid>
            );
          })} */}
        </Grid>
      </Dialog>

      {!openModal && (
        <div>
          <TableToolbar
            title="Instructor List"
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            buttonText="Instructor"
            onButtonClick={() => setOpenModal(true)}
            buttonIcon={<PlusOutlined style={{ fontSize: "14px", color: "black" }} />}
          />
          <div className="space-bar"></div>

          {paginatedInstructors.length > 0 ? paginatedInstructors.map((instructor) => (
            <div className="card-outer" key={instructor.id}>
              <div className="card-outer1">
                <p className="t-card">{instructor.name}</p>
                <p className="t-card">{instructor.contactNumber}</p>
                <p className="t-card">{instructor.email}</p>
                <p className="t-card">{instructor.gender}</p>
              </div>

              <IconButton onClick={(e) => handleMenuClick(e, instructor)}>
                <MoreVert style={{ color: "white" }} />
              </IconButton>
            </div>
          )) : (
            <div style={{ justifyContent: "center", alignItems: "center" }} className="card-outer">No instructors found.</div>
          )}

          <div className="pagination-footer">
            <span style={{ fontSize: "13px" }}>
              Showing {(currentPage - 1) * ITEMS_PER_PAGE + 1} -{" "}
              {Math.min(currentPage * ITEMS_PER_PAGE, filteredInstructors.length)} of{" "}
              {filteredInstructors.length}
            </span>
            <div className="pagination-buttons">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => prev - 1)}
              >
                Prev
              </button>
              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentPage(i + 1)}
                  className={currentPage === i + 1 ? "active" : ""}
                >
                  {i + 1}
                </button>
              ))}
              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((prev) => prev + 1)}
              >
                Next
              </button>
            </div>
          </div>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem onClick={() => {
              handleView();
              handleMenuClose();
            }}>View</MenuItem>
            <MenuItem onClick={() => {
              handleEdit();
              handleMenuClose();
            }}>Edit</MenuItem>
            <MenuItem onClick={() => {
              setIsOpen(true);
              //console.log(`Selected instructor for deletion: ${selectedInstructor ? selectedInstructor.id : "None"}`);
              setSelectedInstructor(selectedInstructor);
              handleMenuClose();
            }}>Delete</MenuItem>
            <MenuItem onClick={() => {
              setIsOpen2(true);
              setSelectedInstructor(selectedInstructor);
              handleMenuClose();
            }}>Reset Password</MenuItem>
          </Menu>
        </div>
      )}

      {openModal && (
        <div>
          <div className="table-title-outer">
            {isViewMode ? (
              <div className="table-title">Edit Instructor</div>
            ) : (
              <div className="table-title">Add New Instructor</div>
            )}
            <IconButton
              className="close-btn"
              onClick={() => {
                setIsViewMode(false);
                window.location.reload();
                setOpenModal(false);
              }}
              style={{ color: "white" }}
            >
              <Close style={{ color: "white" }} />
            </IconButton>
          </div>
          <div className="space-bar"></div>
          <div className="card-outer">
            <Grid container spacing={2} style={{ padding: "16px" }} className="form-grid ">
              <Grid item xs={12} sm={6} md={isViewMode ? 4 : 4}>
                {/* add label */}
                <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Name</FormLabel>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Name"
                  size="small"
                  value={name}
                  onChange={(e) => {
                    const onlyText = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                    setName(onlyText);
                  }}
                  sx={{
                    backgroundColor: "black",
                    input: {
                      color: "#ffffff",
                      "::placeholder": {
                        color: "grey",
                        opacity: 1,
                      },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#555",
                      },
                      "&:hover fieldset": {
                        borderColor: "#aaa",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "gray",
                      },
                    },
                  }}
                />
              </Grid>
              {!isViewMode && (
                <Grid item xs={12} sm={6} md={4}>
                  <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Password</FormLabel>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Password"
                    type="text"
                    size="small"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    sx={{
                      backgroundColor: "black",
                      input: {
                        color: "#ffffff",
                        "::placeholder": {
                          color: "grey",
                          opacity: 1,
                        },
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#555",
                        },
                        "&:hover fieldset": {
                          borderColor: "#aaa",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "gray",
                        },
                      },
                    }}
                  />
                </Grid>
              )}

              {!isViewMode && (
                <Grid item xs={12} sm={6} md={4}>
                  <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Email</FormLabel>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Email"
                    size="small"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    sx={{
                      backgroundColor: "black",
                      input: {
                        color: "#ffffff",
                        "::placeholder": {
                          color: "grey",
                          opacity: 1,
                        },
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#555",
                        },
                        "&:hover fieldset": {
                          borderColor: "#aaa",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "gray",
                        },
                      },
                    }}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6} md={isViewMode ? 4 : 6}>
                <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Contact Number</FormLabel>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Contact Number"
                  size="small"
                  value={contactNumber}
                  onChange={(e) => setContactNumber(e.target.value)}
                  sx={{
                    backgroundColor: "black",
                    input: {
                      color: "#ffffff",
                      "::placeholder": {
                        color: "grey",
                        opacity: 1,
                      },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#555",
                      },
                      "&:hover fieldset": {
                        borderColor: "#aaa",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "gray",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={isViewMode ? 4 : 6}>
                <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Contact Number 2</FormLabel>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Contact Number 2"
                  size="small"
                  value={emergencyContactNumber}
                  onChange={(e) => setEmergencyContactNumber(e.target.value)}
                  sx={{
                    backgroundColor: "black",
                    input: {
                      color: "#ffffff",
                      "::placeholder": {
                        color: "grey",
                        opacity: 1,
                      },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#555",
                      },
                      "&:hover fieldset": {
                        borderColor: "#aaa",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "gray",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Address</FormLabel>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Address"
                  size="small"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  sx={{
                    backgroundColor: "black",
                    input: {
                      color: "#ffffff",
                      "::placeholder": {
                        color: "grey !important",
                        opacity: 1,
                      },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#555",
                      },
                      "&:hover fieldset": {
                        borderColor: "#aaa",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "gray",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControl component="fieldset">
                  <FormLabel
                    component="legend"
                    sx={{
                      color: "#3d3d3dff",
                      "&.Mui-focused": {
                        color: "#3d3d3dff", // Prevent blue on focus
                      },
                      "&.MuiFormLabel-root": {
                        color: "#3d3d3dff",
                      },
                    }}
                  >
                    Gender
                  </FormLabel>

                  <RadioGroup
                    row
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                  >
                    <FormControlLabel
                      value="Male"
                      control={
                        <Radio
                          sx={{
                            color: "#8f8d8dff", // default color
                            "&.Mui-checked": {
                              color: "#bbaf05", // yellow when selected
                            },
                          }}
                        />
                      }
                      label="Male"
                    />
                    <FormControlLabel
                      value="Female"
                      control={
                        <Radio
                          sx={{
                            color: "#8f8d8dff",
                            "&.Mui-checked": {
                              color: "#bbaf05", // yellow when selected
                            },
                          }}
                        />
                      }
                      label="Female"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>
                  Instructor Subjects
                </FormLabel>
                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", backgroundColor: "#1e1e1e", padding: "15px", borderRadius: "0px", maxHeight: "400px", overflowY: "auto", color: "#9a9696ff" }}>
                  {subjectCombinations.map((combo, index) => {
                    const label = `${combo.programme}, ${combo.stream}${combo.subject ? `, ${combo.subject}` : ""}`;
                    const checked = instructorSubjects.some(
                      (s) =>
                        s.programme === combo.programme &&
                        s.stream === combo.stream &&
                        s.subject === combo.subject
                    );
                    return (
                      <Grid item xs={12} sm={6} md={4} key={index} sx={{ marginBottom: 1 }}>
                        <FormControlLabel
                          key={index}
                          control={
                            <Checkbox
                              checked={checked}
                              onChange={() => handleSubjectToggle(combo)}
                              sx={{
                                color: "#8f8d8dff",
                                "&.Mui-checked": { color: "#bbaf05" },
                              }}
                            />
                          }
                          label={label}
                        />
                      </Grid>
                    );
                  })}
                </div>
              </Grid>


            </Grid>
          </div>
          <div className="pagination-footer">
            <div></div>
            {isViewMode ? (
              <Button
                className="primary-btn"
                variant="contained"
                size="small"
                onClick={handleUpdateInstructor}
                startIcon={<PlusOutlined style={{ fontSize: "14px", color: "black" }} />}
                disabled={!name || !contactNumber || !address || !gender || instructorSubjects.length === 0}
              >
                Update Instructor
              </Button>
            ) : (
              <Button
                className="primary-btn"
                variant="contained"
                size="small"
                onClick={handleAddInstructor}
                startIcon={<PlusOutlined style={{ fontSize: "14px", color: "black" }} />}
                disabled={!name || !email || !contactNumber || !password || !address || !gender || instructorSubjects.length === 0}
              >
                Add Instructor
              </Button>
            )}

          </div>
        </div>

      )}
    </div>
  );
}
